/* ==========================================================================
   Onera — Checkout preparation

   Waits for promotions to settle, then redirects to Shopify checkout.
   Event delegation survives partial AJAX refreshes. Vanilla only.
   ========================================================================== */
(function () {
  'use strict';

  const FORM_SELECTOR = '[data-onera-checkout-form]';
  const BUTTON_SELECTOR = '[data-onera-checkout]';
  const LABEL_SELECTOR = '[data-onera-checkout-label-text]';
  const NAV_TIMEOUT_MS = 8000;

  const getCheckoutUrl = function () {
    const config = window.oneraPromoConfig || {};
    return config.checkoutUrl || '/checkout';
  };

  const setPreparing = function (form, preparing) {
    const button = form.querySelector(BUTTON_SELECTOR);
    if (!button) return;

    const defaultLabel =
      button.getAttribute('data-onera-checkout-label') ||
      button.textContent.trim();
    const loadingLabel =
      button.getAttribute('data-onera-checkout-loading') || 'Preparing checkout';
    const labelEl = button.querySelector(LABEL_SELECTOR);

    if (preparing) {
      form.classList.add('is-preparing-checkout');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.classList.add('is-preparing');

      if (labelEl) {
        labelEl.textContent = loadingLabel;
      } else {
        button.textContent = loadingLabel;
      }
      return;
    }

    form.classList.remove('is-preparing-checkout');
    button.disabled = false;
    button.removeAttribute('aria-busy');
    button.classList.remove('is-preparing');

    if (labelEl) {
      labelEl.textContent = defaultLabel;
    } else {
      button.textContent = defaultLabel;
    }
  };

  const resetAll = function () {
    document.querySelectorAll(FORM_SELECTOR).forEach(function (form) {
      setPreparing(form, false);
    });
    syncCheckoutButtons();
  };

  const syncCheckoutButtons = function () {
    const locked =
      (window.oneraCheckoutLock && window.oneraCheckoutLock.isActive()) ||
      document.querySelector('.is-preparing-checkout');

    document.querySelectorAll(BUTTON_SELECTOR).forEach(function (button) {
      const form = button.closest(FORM_SELECTOR);
      if (form && form.classList.contains('is-preparing-checkout')) return;
      button.disabled = !!locked;
    });
  };

  const beginCheckout = function (form) {
    setPreparing(form, true);

    if (window.oneraCheckoutLock) {
      window.oneraCheckoutLock.acquire();
    }

    const stablePromise =
      window.oneraCartPromotions && typeof window.oneraCartPromotions.whenStable === 'function'
        ? window.oneraCartPromotions.whenStable()
        : Promise.resolve();

    let navigated = false;

    const releaseOnFailure = function () {
      if (navigated) return;
      if (window.oneraCheckoutLock) {
        window.oneraCheckoutLock.release();
      }
      setPreparing(form, false);
    };

    const navTimer = window.setTimeout(releaseOnFailure, NAV_TIMEOUT_MS);

    stablePromise
      .then(function () {
        navigated = true;
        window.clearTimeout(navTimer);
        window.location.assign(getCheckoutUrl());
      })
      .catch(function () {
        window.clearTimeout(navTimer);
        releaseOnFailure();
      });
  };

  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target.closest(FORM_SELECTOR);
      if (!form) return;

      const button = form.querySelector(BUTTON_SELECTOR);
      if (!button) return;

      event.preventDefault();

      if (button.disabled || form.classList.contains('is-preparing-checkout')) {
        return;
      }

      beginCheckout(form);
    },
    true
  );

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      if (window.oneraCheckoutLock) {
        window.oneraCheckoutLock.release();
      }
      resetAll();
    }
  });

  document.addEventListener('onera:cart:refresh-idle', syncCheckoutButtons);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCheckoutButtons);
  } else {
    syncCheckoutButtons();
  }
})();
